import { z } from 'zod/v4';
// Types of entities that can be assigned
export const AssignableEntityTypeSchema = z.enum(['order', 'filing', 'case', 'task']);
// Assignment status workflow
export const AssignmentStatusSchema = z.enum([
    'unassigned', // In queue, available for claiming
    'claimed', // Operator claimed from queue
    'assigned', // Admin force-assigned
    'locked', // Currently being worked on
    'completed', // Work finished
    'released', // Released back to queue
]);
// Priority levels aligned with business SLAs
export const AssignmentPrioritySchema = z.enum([
    'standard', // 3 business days (24 business hours)
    'priority', // Next business day (8 business hours)
    'urgent', // Same day (4 business hours)
    'on-demand', // Custom deadline - uses dueAt field directly
]);
export const AssignmentSchema = z.object({
    id: z.string().uuid(),
    entityType: AssignableEntityTypeSchema,
    entityId: z.string().uuid(),
    assigneeId: z.string().uuid().optional(),
    assignedById: z.string().uuid().optional(),
    status: AssignmentStatusSchema,
    priority: AssignmentPrioritySchema,
    // SLA tracking timestamps
    receivedAt: z.string().datetime(),
    firstResponseAt: z.string().datetime().optional(),
    claimedAt: z.string().datetime().optional(), // When the item was claimed
    dueAt: z.string().datetime().optional(),
    resolvedAt: z.string().datetime().optional(),
    // Lock management
    lockedAt: z.string().datetime().optional(),
    lockedById: z.string().uuid().optional(),
    // Metadata
    notes: z.string().optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CreateAssignmentSchema = AssignmentSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    firstResponseAt: true,
    claimedAt: true,
    resolvedAt: true,
    lockedAt: true,
    lockedById: true,
});
export const UpdateAssignmentSchema = AssignmentSchema.partial().omit({
    id: true,
    entityType: true,
    entityId: true,
    createdAt: true,
    receivedAt: true,
});
// Schema for claiming an item from the queue
export const ClaimAssignmentSchema = z.object({
    assignmentId: z.string().uuid(),
});
// Schema for reassigning work (admin only)
export const ReassignmentSchema = z.object({
    assignmentId: z.string().uuid(),
    newAssigneeId: z.string().uuid(),
    notes: z.string().optional(),
});
